export default __webpack_public_path__ + "static/char-v-10-7d475a505de1045d128b4255118768c4.mp4";